import Immutable from 'immutable';
import { createModuleState } from '../moduleregistry';
import { processFilter, processObjectParameters } from './utils';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('SearchForm');


export default class SearchFormModel {
	#data;

	constructor(data = null) {
		this.#data = data || EMPTY_MAP;
	}

	setDefinition(value) {
		return new SearchFormModel(this.#data.set('definition', value));
	}

	getDefinition() {
		return this.#data.get('definition');
	}

	getFilter() {
		let filter = (this.#data.get('filter') || EMPTY_MAP).toJS();
		const definition = this.#data.get('definition');
		processFilter(definition, filter);
		return filter;
	}

	setValue(name, value) {
		return new SearchFormModel(this.#data.setIn(['filter', name], value));
	}

	getRawFilter() {
		return this.#data.get('filter');
	}

	setRawFilter(value) {
		return new SearchFormModel(this.#data.set('filter', value));
	}

	getFilterWithProcessedObjects() {
		return processObjectParameters(this.getFilter());
	}

	clearFilter() {
		return new SearchFormModel(this.#data.set('filter', EMPTY_MAP));
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}

	getData() {
		return this.#data;
	}

}
